import React, { useCallback, useEffect, useMemo } from 'react';
import { bindActionCreators } from 'redux';
import { connect, useSelector } from 'react-redux';

import { Rides } from '../..';
import { renderColumns } from './renderColumns';
import { renderTableHead } from './renderTableHead';
import { copyRide } from '../../../store/drafts';
import { getCustomUserFilter, saveCustomUserFilter, setMyFilter, setFilteredStatus } from '../../../store/rides';
import { useEditReccuringModal } from '../../../hooks/useEditRecurringModal';

import styles from './index.module.css';
import { Navigation } from '../../../utils/navigation';
import { URLS, USER_ROLES } from '../../../constants/constants';
// import { buildUberNeedAttentionCountFilter } from '../../../utils/helpers';
import { fetchAllHealthOrganizations } from '../../../store/health_organizations';

const HO_Rides = ({ copyRide, getCustomUserFilter, savedFilterParams,
  hasSavedFilterParams, healthOrganizations, fetchAllHealthOrganizations, setMyFilter, setFilteredStatus }) => {
  const navigate = Navigation();
  const { EditRecurringModal, handleEditRide, handleRescheduleRide } = useEditReccuringModal();

  const user = useSelector((state) => state.authorization.user);
  const isViewDashboardMode = useSelector(
    (state) => state.authorization?.viewDashboardMode?.active,
  );
  // const isUberEligible = useSelector((state) => state.authorization.isUberEligible);

  // const showNeedAttentionUberHo = Boolean(
  //   isUberEligible ||
  //     user?.isUberEligible ||
  //     user?.orgAddons?.uberHealthEnabled ||
  //     user?.organization?.addons?.uberHealthEnabled ||
  //     user?.addons?.uberHealthEnabled,
  // );

  // const setNeedAttentionFilter = useCallback(() => {
  //   setMyFilter(buildUberNeedAttentionCountFilter({}));
  //   setFilteredStatus(true);
  // }, [setMyFilter, setFilteredStatus]);

  const handleCopyRide = useCallback((ride) => {
    if (ride?.connectedLegId) {
      return copyRide(ride?.leg.toLowerCase() === 'a' ? ride.id : ride?.connectedLegId, navigate)
    }

    return copyRide(ride?.id, navigate)

  }, [copyRide, navigate]);

  const handleRequestNewUberRide = useCallback(
    (id) => {
      if (!id) return;
      navigate.push(URLS.UBER_RESCHEDULE_RIDE.replace(':id', id));
    },
    [navigate],
  );

  const tableColumns = useMemo(
    () =>
      renderColumns({
        handleCopyRide,
        handleEditRide,
        handleRescheduleRide,
        handleRequestNewUberRide,
        navigate,
        user,
        isViewDashboardMode,
      }),
    [handleCopyRide, handleEditRide, handleRescheduleRide, handleRequestNewUberRide, navigate, user, isViewDashboardMode],
  );

  const tableHead = useMemo(() => renderTableHead({ navigate, healthOrganizations, user }), [navigate, healthOrganizations, user]);

  const ridesTable = useMemo(
    () => (
      <div className={styles.table}>
        <Rides
          columns={tableColumns}
          savedFilterParams={savedFilterParams}
          hasSavedFilterParams={hasSavedFilterParams}
          renderTableHead={tableHead}
          // showNeedAttentionBtn={showNeedAttentionUberHo}
          // setNeedAttentionFilter={setNeedAttentionFilter}
        />
      </div>
    ),
    [hasSavedFilterParams, tableHead, tableColumns, savedFilterParams],
  );

  useEffect(() => {
    if (user.role === USER_ROLES.HO_EMPLOYEE) {
      fetchAllHealthOrganizations();
    }
    
    getCustomUserFilter();
     return;
  }, [getCustomUserFilter, fetchAllHealthOrganizations]);
  
  return (
    <>
      {ridesTable}
      {EditRecurringModal}
    </>
  );
};

const mapStateToProps = (state) => ({
  healthOrganizations: state.healthOrganizations.healthOrganizations,
  savedFilterParams: state.rides?.savedFilterParams,
  hasSavedFilterParams: state.rides?.savedFilterParams && Boolean(Object.keys(state.rides?.savedFilterParams)?.length),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchAllHealthOrganizations,
      copyRide,
      getCustomUserFilter,
      saveCustomUserFilter,
      setMyFilter,
      setFilteredStatus,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(HO_Rides);
